module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image05-cf5db035c23523cf0730fd23f5d38e8f.png";